import type { MouseEvent } from "react";

/** What in a clickable row does its own thing on a click (the row ignores a click on one). */
export const CONTROLS = "a, button, input, label, select, textarea";

/** The props of a table row with a checkbox (docs/ui-design.md): marked as clickable and, when ``selected``, as
 *  selected; a click anywhere on it ticks or unticks it, except on a control of its own (the checkbox keeps its own
 *  onChange, links and buttons do their own thing). ``enabled`` false: an ordinary row with ``className``. */
export function rowToggle({
  selected,
  onToggle,
  enabled = true,
  className,
}: {
  selected: boolean;
  onToggle: () => void;
  enabled?: boolean;
  className?: string;
}) {
  if (!enabled) return { className };
  return {
    className: [className, "click", selected && "sel"].filter(Boolean).join(" "),
    onClick: (e: MouseEvent) => {
      if (!(e.target as Element).closest(CONTROLS)) onToggle();
    },
  };
}
